import type { ResponseOf } from "../../core/api";

type Patient = ResponseOf<"get", "/agencies/:agencyId/patients/:patientId">;

export type PatientProfileDisplayData = {
  assignedCoordinatorName: string;
  currentOfficeName: string;
  agencyTeamName: string;
  addressText: string;
};

const missingValue = "";

function fromId(label: string, id: number | string | null | undefined) {
  return id === null || id === undefined ? missingValue : `${label} #${id}`;
}

function getAddressText(address: Patient["address"]) {
  if (address === null) {
    return missingValue;
  }

  if ("text" in address && typeof address.text === "string" && address.text.length > 0) {
    return address.text;
  }

  return missingValue;
}

export function mapPatientProfileDisplayData(patient: Patient): PatientProfileDisplayData {
  return {
    addressText: getAddressText(patient.address),
    agencyTeamName: patient.agencyTeamName ?? fromId("Team", patient.agencyTeamId),
    assignedCoordinatorName:
      patient.assignedCoordinatorName ?? fromId("Agency member", patient.assignedCoordinator),
    currentOfficeName: patient.currentOfficeName ?? fromId("Office", patient.currentOfficeId),
  };
}
